export function homeSlider() {

    var $homeSlider = jQuery( ".js-home-slider" );

    $homeSlider.on('init', function(event, slick){
        $(this).append('<div class="slider-count"><span id="current">1</span>   of   <span id="total">'+slick.slideCount+'</span></div>');
    });

    if ($(window).width() > 767){
        $homeSlider.slick({
            dots: false,
            infinite: false,
            arrows: true,
            fade: true,
            speed: 600,
            slidesToShow: 1,
            slidesToScroll: 1,
            

        });

    }

    $homeSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
        $('.slider-count #current'). html(currentSlide+1);

    });


    $(document).keydown(function(e){
        if (e.which == 37) {
            $('.slick-prev').click();
        } else if (e.which == 39) {
            $('.slick-next').click();
        }
    });

 

}


// WEBPACK FOOTER //
// ./assets/js/modules/home-slider.js